import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ROLES from 'constants/roles';
import { BlockLink } from '../../components/Animations';
import clients from '../../assets/images/clients.png';
// import myInformation from '../../assets/images/clients.png';
import mobile from '../../assets/images/apps.png';
import taxInflation from '../../assets/images/tax.png';
import rates from '../../assets/images/adjustable.png';
import contacts from '../../assets/images/clients.png';
import PageTitle from 'components/layout/PageTitle';

class ClientInfo extends Component {
  constructor(props) {
    super(props);
  }


  componentDidMount() {}
  hasPermission(checkPermissions = []) {
    const availablePermissions =
      localStorage.getItem("permissionState") != "undefined" &&
      JSON.parse(localStorage.getItem("permissionState") || null);
    return checkPermissions.some(
      (p) => availablePermissions && availablePermissions.includes(p)
    );
  }

  render() {
    const block_links = [
      // {
      //   href: '/clients/plans', //new='/clients/plans' old='/clients_plans'
      //   title: 'Clients and Plans',
      //   visible:
      //     this.props.user.role == ROLES.CONSUMER ||
      //     this.props.user.role == ROLES.FREE_APP_SUITE
      //       ? false
      //       : true,
      //   img: clients,
      // },
      // {
      //   href: '/my_information',
      //   title: 'My Information',
      //   visible: this.props.user.role == ROLES.CONSUMER ? true : false,
      //   //  img: myInformation
      // },
      // {
      //   href: '/',
      //   title: 'Mobile Sync',
      //   visible: true,
      //   img: mobile,
      // },
      {
        href: '/client/plan',
        title: 'Client Contacts',
        visible: true,
        img: contacts,
        permission:["Super Admin", "List All Cloud Contacts"],
      },
      {
        // href: '/tax_inflation',
        href: '/tax_inflation_edit/1',
        title: 'Tax and Inflation',
        visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
        img: taxInflation,
        permission: ["Super Admin", "FetchTaxAndInflation"],
      },
      // {
      //   href: '/rates_of_return',
      //   title: 'Rates of Return',
      //   visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
      //   img: rates,
      //   permission: ["Super Admin", "FetchRatesOfReturn"],
      // },
     
      // {
      //   href: '/custom_components',
      //   title: 'Custom Components',
      //   visible: true,
      //   img: contacts,
      // },
    ];
    return (
      <React.Fragment>
        <div className='page-nav-history'>
          <div style={{ marginBottom: '5em' }}>
            <PageTitle title='Client Information' />
          </div>
        </div>
        <div className='module-blocks'>
        {/*
          {block_links.map((blocklink, bindex) => {
            if (blocklink.visible) {
              return (
                <BlockLink
                  key={bindex}
                  img={blocklink.img}
                  className='module-block-link'
                  link={blocklink.href}
                  title={blocklink.title}
                />
              );
            } else {
              return <React.Fragment></React.Fragment>;
            }
          })}
        */}
        {block_links.map((blocklink, bindex) => {
          return (
            <div key={bindex} className="module-block-link">
              <Link
                to={{
                  pathname: blocklink.href,
                  state: { title: blocklink.title },
                }}
                style={{
                  pointerEvents: this.hasPermission(blocklink.permission)
                    ? ""
                    : "none",
                }}>
                <div
                  className={"button-wrap-goals"}
                  style={{
                    cursor: this.hasPermission(blocklink.permission)
                      ? ""
                      : "not-allowed",
                    pointerEvents: this.hasPermission(blocklink.permission)
                      ? ""
                      : "none",
                    opacity: this.hasPermission(blocklink.permission)
                      ? "1"
                      : "0.5",
                  }}>
                  <div style={{ flexDirection: "column" }}>
                    <div className="col-12 mt-2 mb-2">
                      <img src={blocklink.img} className="img-btn" />
                    </div>
                    <div className="col-12 mb-2 mt-2">{blocklink.title}</div>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.rootReducer.loginUser.loginUserData
  };
};
export default connect(mapStateToProps, null)(ClientInfo);
